/*
 * Visit colors from Settings, Schedule, "Colors by word": a visit whose job name has the word takes that color on the
 * Schedule (old Steward calColors). Crew, who can't read settings, keep the kind colors.
 */
import { scheduleColor, type Settings, type VisitCard } from "@steward/shared";
import type { CSSProperties } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";
import { useSession } from "../app/session";

export function useWordColor(): (v: VisitCard) => CSSProperties | undefined {
  const { company, can } = useSession();
  const s = useQuery({
    queryKey: ["settings", company.id],
    queryFn: () => api<{ settings: Settings; own: Record<string, unknown> }>("GET", "settings"),
    enabled: can("settings.read"),
  });
  const settings = s.data?.settings;
  return (v) => {
    const c = settings ? scheduleColor(v.jobName, settings) : null;
    return c ? { ["--kind" as string]: c } : undefined;
  };
}
